export default "__VITE_ASSET__3d3f6281__"